import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = (baseURL => {
  return {
    listDynamicContentByIdMessage: idMessage =>
      `${baseURL}/api/dynamiccontents/message/${idMessage}`,
    getFolderContentMetadata: idMessage =>
      `${baseURL}/api/message/${idMessage}/attachment/info`,
    setAttachmentsConfiguration: idMessage =>
      `${baseURL}/api/message/${idMessage}/attachments`,
    getMessageLinks: (idMessage, params) =>
      `${baseURL}/api/message/${encodeURIComponent(
        idMessage
      )}/links?${encodeParams(params)}`,
    getMessageDetailsLazy: idMessage =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}/lazy`,
    getEntitiesThatUseMessage: idMessage =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}/entities`,
    createMessageThumbnail: idMessage =>
      `${baseURL}/api/thumbnail/${idMessage}`,
    deleteMessage: idMessage =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}`,
    setSelfImport: idList =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/selfImport`,
    getHtmlMessageExportUrl: idMessage =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}/export/html`,
    getPdfMessageExportUrl: idMessage =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}/export/pdf`,
    createPlainText: idMessage =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}/plaintext`,
    savePlainText: idMessage =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}/plaintext`
  }
})(process.env.BEEMAILMESSAGE_URL)

/**
 * @typedef {Object} DynamicContentItem
 * @property {number} Id
 * @property {boolean} Active
 * @property {string} Name
 *
 * @description return all dynamic contents of a message
 * @param {number} idMessage message id
 * @return {Array<DynamicContentItem>} return a dynamic content by id message
 */
export const beEmailMessageApiListDynamicContentByIdMessage = idMessage => {
  return apiWrapper({
    method: 'get',
    url: endpoints.listDynamicContentByIdMessage(idMessage)
  }).then(extractApiData)
}

/**
 * @typedef {Object} ContentMetadata
 * @property {string} FileName
 * @property {number} FileSize
 *
 * @typedef {Object} FolderContentMetadataResponse
 * @property {Array<ContentMetadata>} Items
 *
 * @description ets folder content metadata
 * @param {number} idMessage message id
 * @return {FolderContentMetadataResponse}
 */
export const beEmailMessageApiGetFolderContentMetadata = idMessage => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getFolderContentMetadata(idMessage)
  }).then(extractApiData)
}

export const beEmailMessageApiSetAttachmentsConfiguration = (
  idMessage,
  attachments
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.setAttachmentsConfiguration(idMessage),
    data: JSON.stringify({ Files: attachments })
  }).then(extractApiData)
}

export const beEmailMessageApiCreateMessageThumbnail = idMessage => {
  return apiWrapper({
    method: 'post',
    url: endpoints.createMessageThumbnail(idMessage)
  }).then(extractApiData)
}

/**
 * @description Get the message links
 * @param {number} idMessage
 * @returns {object}
 */
export const beEmailMessageApiGetMessageLinks = (
  idMessage,
  { withwebtracking } = {
    withwebtracking: true
  }
) => {
  const url = endpoints.getMessageLinks(idMessage, {
    withwebtracking,
    excludesendtoafriend: true
  })

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

/**
 * @description Get the message details lazy
 * @param {number} idMessage
 * @returns {object}
 */
export const beEmailMessageApiGetMessageDetailsLazy = idMessage => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getMessageDetailsLazy(idMessage)
  }).then(extractApiData)
}
export const beEmailMessageApiGetEntitiesThatUseMessage = idMessage => {
  const url = endpoints.getEntitiesThatUseMessage(idMessage)
  //  'Trigger', 'DynamicContent', 'Anagraphic_Filter', 'Activity_Filter', 'None', 'AutomationWorkflow', 'ABTest', 'Welcome', 'Confirmation', 'AggregateReport'
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}
export const beEmailMessageApiSetSelfImport = (idList, message) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.setSelfImport(idList),
    data: JSON.stringify(message)
  }).then(extractApiData)
}

export const beEmailMessageApiDeleteMessage = idMessage => {
  const url = endpoints.deleteMessage(idMessage)

  return apiWrapper({
    method: 'delete',
    url: url
  }).then(extractApiData)
}

export const beEmailMessageApiGetMessageHtmlExport = idMessage => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getHtmlMessageExportUrl(idMessage)
  }).then(extractApiData)
}

export const beEmailMessageApiGetMessagePdfExport = idMessage => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getPdfMessageExportUrl(idMessage)
  }).then(extractApiData)
}

export const beEmailMessageApiCreatePlainText = idMessage => {
  return apiWrapper({
    method: 'post',
    url: endpoints.createPlainText(idMessage)
  }).then(extractApiData)
}

export const beEmailMessageApiSavePlainText = (idMessage, data) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.savePlainText(idMessage),
    data: JSON.stringify(data)
  }).then(extractApiData)
}
